export default "__VITE_ASSET__D46sxbw1__"